import RemoveFromCartNormalizersResolver from "./RemoveFromCartNormalizersResolver";
import AbstractDataBuilder from "../../core/AbstractDataBuilder";
export default class RemoveFromCartDataBuilder extends AbstractDataBuilder {
    static create() {
        if (undefined === this.builderInstance) {
            this.builderInstance = new this(new RemoveFromCartNormalizersResolver());
        }
        return this.builderInstance;
    }
}
